var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretCircleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.1875C14.267 7.1875 7.1875 14.267 7.1875 23C7.1875 31.733 14.267 38.8125 23 38.8125C31.733 38.8125 38.8125 31.733 38.8125 23C38.8125 14.267 31.733 7.1875 23 7.1875ZM4.3125 23C4.3125 12.6792 12.6792 4.3125 23 4.3125C33.3208 4.3125 41.6875 12.6792 41.6875 23C41.6875 33.3208 33.3208 41.6875 23 41.6875C12.6792 41.6875 4.3125 33.3208 4.3125 23Z",
    fill: "#3A2742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9435 15.5696C27.4746 16.1597 27.4267 17.0687 26.8366 17.5997L20.8363 23L26.8366 28.4003C27.4267 28.9314 27.4746 29.8403 26.9435 30.4304C26.4124 31.0205 25.5035 31.0683 24.9134 30.5372L17.7259 24.0685C17.423 23.7959 17.25 23.4075 17.25 23C17.25 22.5925 17.423 22.2041 17.7259 21.9315L24.9134 15.4628C25.5035 14.9317 26.4124 14.9795 26.9435 15.5696Z",
    fill: "#F7F7F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretCircleLeft);
export default __webpack_public_path__ + "static/media/CaretCircleLeft.52f65e9a829227a090a6ad7b6688b289.svg";
export { ForwardRef as ReactComponent };